/**
 * @param {string} url
 * @return {Promise<void>}
 */
export default async function loadJSON(url) {
  try {
    const response = await fetch(url, {credentials: 'same-origin'});
    if (response.ok) {
      if (response.headers.get('content-type').includes('application/json')) {
        return response.json();
      } else if (response.headers.get('content-type').includes('text/html')) {
        return response.text();
      } else {
        throw new Error('Unknown content type');
      }
    } else {
      if (response.status === 404) {
        throw new Error('Data not found');
      }
    }
  } catch (err) {
    console.log('Loading data error: ', err);
    throw new Error(err);
  }
}
